<pr-stripe-sms-pricing-selector
  readOnly
  class="p-4"
  [region]="region()"
  [selectedPrices]="data$ | async"
/>

<div class="flex flex-col gap-4">
  <h3 class="mat-subtitle-1">Billing Summary</h3>
  <div class="flex justify-between gap-4">
    <pt-date-range-form
      *ngIf="dateRange$ | async as dateRange"
      [useRangePicker]="true"
      [from]="dateRange.from"
      [to]="dateRange.to"
      (changed)="updateDates($event)"
    />
    <pt-loader-button
      class="billing-button"
      color="primary"
      type="flat"
      [loading]="loading$ | async"
      (click)="getSMSBillingDetails()"
    >
      View Billing Summary
    </pt-loader-button>
  </div>
</div>

<div *ngIf="billingDetails$ | async as billingDetails">
  <div class="flex flex-col gap-4">
    <div *ngFor="let summary of billingDetails; trackBy: trackByBillingDetails">
      <h4>{{ summary.practiceName }}</h4>
      <div class="flex flex-col gap-1">
        <div>
          <strong>Inbound Segments: </strong>
          <span>{{ summary.inboundSegments }}</span>
        </div>
        <div>
          <strong>Inbound Total: </strong>
          <span>{{ summary.inboundTotal | currency }}</span>
        </div>
        <div>
          <strong>Outbound Segments: </strong>
          <span>{{ summary.outboundSegments }}</span>
        </div>
        <div>
          <strong>Outbound Total: </strong>
          <span>{{ summary.outboundTotal | currency }}</span>
        </div>
        <div>
          <strong>Total: </strong>
          <span>{{ summary.total | currency }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
